export enum UserStatus {
    Enabled = 1,
    New = 0,
    Disabled = 2
}